import { Component } from 'react';
import { connect } from 'react-redux';
import api from 'api';
import { Box } from 'components/common/box';

const ChaptersHeatmap = connect((state) => state)(
  class extends Component {
    state = {
      loading: true,
      data: null
    };

    componentDidMount() {
      this.getData();
    }

    getData = async () => {
      const {
        dispatch,
        pageState: { course }
      } = this.props;
      try {
        const response = await api.get(
          `/admin/courses/${course.id}/analytics/chapters`
        );
        this.setState({ data: response.data, loading: false });
      } catch (err) {
        await dispatch.handleErrorDispatch(err);
      }
    };

    handleImageError = (ev) => {
      ev.target.src = '/static/img/block_placeholder.png';
      ev.target.parentElement.classList.add('broken');
    };

    render() {
      const {
        messages,
        pageState: { course },
        theme
      } = this.props;
      const { data, loading } = this.state;

      const heatmapColors = [
        '#ffffff',
        '#fff5f0',
        '#fee0d2',
        '#fcbba1',
        '#fc9272',
        '#fb6a4a',
        '#ef3b2c',
        '#cb181d',
        '#99000d'
      ];

      return (
        <div className="chapter-analytics">
          <Box loading={loading} title={messages.analyticsChapterAnalytics}>
            {data ? (
              <>
                <div>
                  <div className="colors-label">
                    {messages.analyticsLeastViewed}
                  </div>
                  <div className="colors">
                    {heatmapColors.slice(1).map((color) => (
                      <div
                        className="color"
                        key={color}
                        style={{ backgroundColor: color }}
                      />
                    ))}
                  </div>
                  <div className="colors-label">
                    {messages.analyticsMostViewed}
                  </div>
                </div>
                <div className="chapters">
                  {data.chapters.map((chapter) => (
                    <div className="chapter" key={chapter.id}>
                      <a
                        className="chapter-title"
                        href={`/courses/${course.slug}/${chapter.slug}`}
                        rel="noopener noreferrer"
                        target="blank"
                      >
                        {`${chapter.number}. ${chapter.title}`}
                      </a>
                      <div className="chapter-blocks">
                        {chapter.blockPositions.map((blockId) => (
                          <a
                            className="block"
                            href={`/courses/${course.slug}/${chapter.slug}#${blockId}`}
                            key={blockId}
                            rel="noopener noreferrer"
                            target="blank"
                          >
                            <div
                              className="block-value"
                              style={{
                                backgroundColor:
                                  heatmapColors[chapter.blockValues[blockId]]
                              }}
                            />
                            <div className="block-preview">
                              <img
                                alt="block thumbnail"
                                onError={this.handleImageError}
                                src={`${data.blockThumbnailUrl}/${blockId}.png`}
                              />
                            </div>
                          </a>
                        ))}
                      </div>
                    </div>
                  ))}
                </div>
              </>
            ) : null}
          </Box>

          <style jsx>{`
            .colors-label {
              color: ${theme.textColorLighter};
              display: inline-block;
              font-size: 1.4rem;
              font-weight: 600;
              vertical-align: top;
            }
            .colors {
              border-radius: 2px;
              display: inline-block;
              margin: 0 10px;
              overflow: hidden;
            }
            .color {
              display: inline-block;
              height: 20px;
              float: left;
              width: 20px;
            }
            .chapter {
              display: inline-block;
              margin-right: 40px;
              margin-top: 30px;
              vertical-align: top;
              width: 170px;
            }
            .chapter-title {
              color: ${theme.textColor};
              display: inline-block;
              font-size: 1.4rem;
              font-weight: 700;
              margin-bottom: 10px;
              padding-left: 12px;
              text-decoration: none;
            }
            .chapter-blocks {
              padding-right: 40px;
            }
            .block {
              color: inherit;
              display: block;
              padding-left: 10px;
              position: relative;
              text-decoration: none;
              width: 100%;
            }
            .block-value {
              position: absolute;
              left: 0;
              top: 0;
              bottom: 0;
              width: 6px;
            }
            .block-preview img {
              max-width: 100%;
            }
            .block-preview.broken::before {
              content: 'preview missing';
              font-size: 1.2rem;
              padding: 10px;
              position: absolute;
            }
          `}</style>
        </div>
      );
    }
  }
);

export default ChaptersHeatmap;
